import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; 


const LoginSuccess = () => {
  const navigate = useNavigate();

 useEffect(() => {
  try {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');
    console.log('Token from URL:', token);

    if (token != null) {
      const decoded = jwtDecode(token);

      // Chuẩn hóa dữ liệu user
      const user = {
        userId: decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"],
        fullName: decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"],
        email: decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"],
        role: decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]
      };

      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('token', token);
      console.log('User logged in successfully:', user);

      navigate('/');
      window.location.reload();
    }
  } catch (err) {
    console.error('Error in login success:', err);
  }
}, [navigate]);


  return <div>🔐 Logging in... Please wait...</div>;
};

export default LoginSuccess;
